import { render, staticRenderFns } from "./BankAccountList.vue?vue&type=template&id=422ebfa1&scoped=true&"
import script from "./BankAccountList.vue?vue&type=script&lang=js&"
export * from "./BankAccountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422ebfa1",
  null
  
)

export default component.exports